import React from 'react'
import { useSurveyNode } from '../../../Hooks/Features/SurveyManagement/SurveyNode/useSurveyNode'
import { Dialog } from 'primereact/dialog';
import CreateNode from '../../../components/SurveyNodes/CreateNode';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPenToSquare, faTrashCan, faUser } from '@fortawesome/free-regular-svg-icons';
import { useCommon } from '../../../Hooks/Features/Pocker/useCommon';
import { Dropdown } from 'primereact/dropdown';
import { SkeletonContainer } from '../../../components/Loader/Loader';
import CommanDialog from '../../../components/CommonCompo/CommanDialog/CommanDialog';
import CommonFilterDropdown from '../../../components/CommonCompo/CommonFilterDropdown/CommonFilterDropdown';
import { useCommon as UseCommonPermission } from '../../../Hooks/Common/useCommon';

const SurveyNodes = () => {

    const {getValuePermission} = UseCommonPermission();
    const { getUserInitials } = useCommon();
    const { showCreate, setShowCreate, getNodes, nodes, options, handleRelationChange, loader, deleteNode, filterValues, setFilterValues } = useSurveyNode();

    return ( !getValuePermission("evaluate_tab") && 
        <div style={{ backgroundColor: "#f4f5f7" }} className='px-2'>
            <div className='d-flex justify-content-between align-items-center'>
                <div className='w60'>
                    <CommonFilterDropdown fields={[{ key: "users", label: "Users", col: 4 }]} filterValues={filterValues} setFilterValues={setFilterValues} />
                </div>
                <div className='d-flex justify-content-end gap-1 py-2'>
                    <button className='sk-btn sk-btn-primary ' onClick={() => getNodes()} title='Refresh'><FontAwesomeIcon icon="fa-solid fa-arrows-rotate" /></button>
                    <button className='sk-btn sk-btn-primary bg-black text-white' onClick={() => setShowCreate((prev) => ({ ...prev, visible: true }))}>+ Add Node</button>
                </div>
            </div>

            {loader?.card ?
                <div className='d-flex gap-3 flex-wrap' style={{ minHeight: "calc(100vh - 95px)" }}>
                    {Array.from({ length: 3 }, (_, index) => (
                        <div style={{ width: "400px", height: "280px" }}><SkeletonContainer /></div>
                    ))}
                </div> :
                <div style={{ minHeight: "calc(100vh - 95px)" }}>
                    <div className='d-flex gap-3 flex-wrap'>
                        {nodes?.map(node => (
                            <div key={node?.node_id} className='sk-card-container p-0' style={{ width: "400px", backgroundColor: "#fdfdfd80", height: "280px" }}>
                                <div className='d-flex align-items-center justify-content-between py-2 px-3 border-bottom' style={{ height: "15%" }}>
                                    <div className='fw-bold fs-6'>{node?.node_name}</div>
                                    <div className='d-flex' style={{ gap: "10px" }}>
                                        <div className='c-pointer text-primary' onClick={() => setShowCreate((prev) => ({ ...prev, visible: true, data: node }))}><FontAwesomeIcon icon={faPenToSquare} /></div>
                                        <div className='c-pointer text-danger' onClick={() => setShowCreate((prev) => ({ ...prev, delete: { visible: true, data: node } }))}><FontAwesomeIcon icon={faTrashCan} /></div>
                                    </div>
                                </div>
                                <div className='p-2 overflow-y-auto d-flex flex-column gap-2' style={{ height: "70%" }}>
                                    {node?.members?.map(user => (
                                        <div className='d-flex justify-content-between align-items-center px-2 py-1 bg-white rounded shadow-sm'>
                                            <div className='text-truncate fw-semibold'>{user?.node_member_name}</div>
                                            {loader?.dropdown?.[`${node?.node_id}-${user?.node_member_user_code}`] ?
                                                <div style={{ width: "100px", height: "28px" }}>
                                                    <SkeletonContainer />
                                                </div> :
                                                <div><Dropdown className='node-dd' style={{ backgroundColor: "#d6e6ff" }} options={options?.relations} optionLabel='relation_name' optionValue='relation_id' value={user?.relation_id} filter filterInputAutoFocus onChange={(e) => handleRelationChange(node, user, e)} /></div>
                                            }
                                        </div>
                                    ))}
                                </div>
                                <div className='py-2 px-3 border-top d-flex align-items-center gap-3 fw-semibold text-uppercase' style={{ fontSize: "0.65rem", color: "#999999", height: "15%" }}>
                                    <div className='d-flex align-items-center gap-2'>
                                        <div style={{ fontSize: "10px" }}><FontAwesomeIcon icon={faUser} /></div>
                                        <div style={{ width: "max-content" }}>{node?.members?.length || 0} members</div>
                                    </div>
                                    <div className='d-flex row-gap-1 gap-2 align-items-center flex-wrap'>
                                        {Object.entries(node?.relationsCount)?.map(([key, value]) => (
                                            <div className='d-flex align-items-center gap-1'>
                                                <div style={{ fontSize: "5px" }}><FontAwesomeIcon icon="fa-solid fa-circle" /></div>
                                                <div>{key}: {value?.length}</div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            }

            <Dialog visible={showCreate?.visible} onHide={() => setShowCreate((prev) => ({ ...prev, visible: false, data: null }))} draggable={false} className='modal-xlarge' header={showCreate?.data ? "Edit Node" : "Create Node"} style={{ height: "80vh" }}>
                <CreateNode editNode={showCreate?.data} onClose={() => { setShowCreate((prev) => ({ ...prev, visible: false, data: null })); getNodes(); }} nodeOptions={options} />
            </Dialog>

            <CommanDialog visible={showCreate?.delete?.visible} handleClose={() => setShowCreate((prev) => ({ ...prev, delete: { visible: false, data: null } }))} handleFun={() => deleteNode()} message="Are you sure you want to delete this node?" loader={loader?.delete} />
        </div>
    )
}

export default SurveyNodes